<template>
  <div class="calico-navigation-tab">
    <router-link
      class="link"
      :class="[
        variant,
        { disabled, active: $route.hash === '#' + ($attrs.to.split('#')[1] || '') }
      ]"
      v-bind="$attrs"
      tabindex="0"
    >
      <slot />
    </router-link>
  </div>
</template>

<script>
export default {
  name: "CalicoNavigationTab",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "default", // 'default' | 'alt'
      validator: (v) => ["default", "alt"].includes(v),
    },
  },
};
</script>

<style lang="scss" scoped>
.calico-navigation-tab {
  .link {
    @include inline-space($space-medium);
    @include inset-space($space-medium);

    gap: $space-medium;
    padding: $space-small $space-medium;
    border-radius: $radius-small;

    text-decoration: none;
    background: transparent;
    color: $color-black;

    &:hover:not(.disabled) {
      background-color: $color-neutral-light;
    }

    &.disabled {
      pointer-events: none;
      color: $color-neutral;
      background-color: transparent;
    }

    /* Default active */
    &.active {
      color: $color-lapis;
      background-color: $color-neutral-lightest;
    }
    
    /* Alt variant */
    &.alt {
      background-color: $color-black-lightest;
      color: $color-black;

      &:hover:not(.disabled):not(.active) {
        background-color: $color-black-lightest;
      }

      &.active {
        background-color: $color-black;
        color: $color-white;
        
        &:hover:not(.disabled) {
          background-color: $color-black;
        }
      }

      &.disabled {
        background-color: transparent;
        color: $color-neutral;
        
        &:hover {
          background-color: transparent;
        }
      }
    }
  }
}
</style>
